module.exports = __webpack_public_path__ + "static/img/018.89b34c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/018.png
// module id = fyAv
// module chunks = 0